import React, { FC } from 'react';
import { PopupModalProps } from './PopupModalProps';
import Modal, { ModalBody, Prompt } from '@ingka/modal';
import Text from '@ingka/text';

const PopupModal: FC<PopupModalProps> = ({ visible }) => {
  return (
    <Modal
      visible={visible}
      handleCloseBtn={() => {
        //Do nothing
      }}
    >
      <Prompt
        title={'You are almost there!'}
        header={null}
        titleId={'pop-up-modal-title-id'}
        footer={null}
      >
        <ModalBody>
          <Text>
            Please un-block the pop ups and refresh the page in order to login
            into RELTP!
          </Text>
        </ModalBody>
      </Prompt>
    </Modal>
  );
};

export default PopupModal;
